import PropTypes from "prop-types"
import { usePageAssets } from "hooks/usePageAssets"
import Heading from "components/ui/Heading"
import SkewedSection from "components/ui/Layout/SkewedSection"
import SplitContainer from "components/ui/Layout/SplitContainer"

function CustomizableAnalyticsSection({ className }) {
  const { getAsset } = usePageAssets()
  const illustration = getAsset("customer-apps-customizable-analytics")
  return (
    <SkewedSection className={className}>
      <SplitContainer
        className="py-10 lg:py-20 xl:py-32 2xl:py-40"
        image={illustration}
        imageClassName="mt-8 md:mt-0 max-w-2xl mx-auto"
      >
        <Heading
          label="Customizable Analytics"
          title="Create a better user experience with tailored analytics"
          subtitle={
            <>
              Give customers access to the most relevant set of charts and
              metrics, so they can make informed decisions. Preset makes it easy
              to customize interactive dashboards for individual users,
              accounts, or industry verticals.
            </>
          }
          narrow
        />
      </SplitContainer>
    </SkewedSection>
  )
}

CustomizableAnalyticsSection.propTypes = {
  /** Additional className(s) */
  className: PropTypes.string,
}

export default CustomizableAnalyticsSection
